<template>
  <section id="footer" class="section-footer">
    <div class="footer__navigation">
      <div class="footer-address">
        <p>
          Jeanna Chambers Photography &copy; {{ new Date().getFullYear() }}
          <br />
          Cañon City, CO 81212
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.footer-img {
  z-index: 10;
  padding: 1rem;
  // padding-top: 5rem;
  flex: 1 2 50%;
  max-width: 50%;

  &-address {
    // padding-top: 6rem;
    display: flex;
    flex-direction: column;
    align-self: center;
    width: 50vw;
    text-align: center;
    margin-bottom: 5rem;
  }

  &__navigation {
    align-self: center;
    height: 100%;
  }
}
</style>
